import { LoadingState as PxLoadingState, ErrorState as PxErrorState } from '@roi-pros/px-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function LoadingSpinner({ size = 'md' }: LoadingSpinnerProps) {
  return (
    <svg
      className={`animate-spin ${sizeClasses[size]} text-blue-600`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

// B4 Platform adoption: LoadingState / ErrorState now render via the Platform Experience
// canonical states (@roi-pros/px-react). The component API (the `message` prop) is unchanged,
// so all call sites, routing, and page logic are untouched — the application still decides WHEN
// to show these states; the Platform owns HOW they are rendered (layout, a11y, tokens).
// These are thin, application-owned adapters that map the app's props onto the Platform model;
// the Platform components are consumed as-is (no fork, no application-specific variant).
export function LoadingState({ message = 'Loading...' }: { message?: string }) {
  return <PxLoadingState title={message} />;
}

export function ErrorState({ message }: { message: string }) {
  return <PxErrorState model={{ kind: 'error', title: message }} />;
}
